import { createBrowserRouter, RouterProvider, Outlet, useSearchParams, useLocation } from "react-router-dom";
import SignIn from "./pages/AuthPages/SignIn";
import { Navigate } from "react-router-dom";
import AppLayout from "./layout/AppLayout";
import { ScrollToTop } from "./components/common/ScrollToTop";
import TenantEmployee from "./pages/Outlet/TenantEmployee";
import Home from "./pages/Dashboard/Home";
import SafetyTask from "./pages/Tenant-relation/SafetyTask";
import SafetyTaskForm from "./pages/Tenant-relation/SafetyTaskForm";
import UserProfiles from "./pages/UserProfiles";
import ProtectedRoute from "./components/common/ProtectedRoute";
import Announcements from "./pages/Tenant-relation/announcements";
import Information from "./pages/Tenant-relation/information";
import TenantNews from "./pages/Tenant-relation/tenantNews";
import OutletPage from "./pages/Outlet/Index";
import VendorDetail from "./pages/VendorManagement/VendorDetail";
import SalesUpload from "./pages/Sales/SalesUpload";
import Transaction from "./pages/Sales/Transaction";
import Summary from "./pages/Sales/Summary";
import ActivationForm from "./pages/ActivationForm";
import TenantEmployeeForm from "./pages/Outlet/components/TenantEmployeeForm";
import TenantRequest from "./pages/Tenant-relation/tenantRequest";
import WorkPermit from "./pages/Tenant-relation/workPermit";
import WorkPermitForm from "./pages/Tenant-relation/workPermitForm";
import MallTraffic from "./pages/Outlet/Malltrafic";
import PestControl from "./pages/Outlet/PestControl";
import Playup from "./pages/Tenant-relation/playup";
import LinknetPage from "./pages/Tenant-relation/linknet";
import RevenueMonitor from "./pages/Sales/RevenueMonitor";
import TenantAccessLogin from "./pages/AuthPages/TenantAccessLogin";
import ThanksPage from "./pages/ThanksPage";
import { AppWrapper } from "./components/common/PageMeta";

import { ThemeProvider } from "./context/ThemeContext.tsx";

const RootHandler = () => {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");

  if (code) {
    return <TenantAccessLogin />;
  }

  const publicPaths = ["/login", "/Inactivate", "/thanks"];
  if (publicPaths.includes(pathname)) {
    return <Outlet />;
  }

  return <ProtectedRoute />;
};

const router = createBrowserRouter([
  {
    element: (
      <ThemeProvider>
        <AppWrapper>
          <ScrollToTop />
          <Outlet />
        </AppWrapper>
      </ThemeProvider>
    ),
    children: [
      {
        element: <RootHandler />,
        children: [
          {
            path: "/",
            children: [
              {
                path: "login",
                element: <SignIn />,
              },
              {
                path: "Inactivate",
                element: <ActivationForm />,
              },
              {
                path: "thanks",
                element: <ThanksPage />,
              },
              {
                element: <AppLayout />,
                children: [
                  {
                    index: true,
                    element: <Home />,
                  },
                  {
                    path: "profile",
                    element: <UserProfiles />,
                  },
                  {
                    path: "outlet/detail",
                    element: <OutletPage />,
                  },
                  {
                    path: "outlet/employee",
                    element: <TenantEmployee />,
                  },
                  {
                    path: "outlet/employee/form",
                    element: <TenantEmployeeForm />,
                  },
                  {
                    path: "outlet/pestcontrol",
                    element: <PestControl />,
                  },
                  {
                    path: "vendor-management/detail",
                    element: <VendorDetail />,
                  },
                  {
                    path: "vendor-management/employee",
                    element: <TenantEmployee />,
                  },
                  {
                    path: "vendor-management/employee/form",
                    element: <TenantEmployeeForm />,
                  },
                  {
                    path: "vendor-management/work-permit",
                    element: <WorkPermit />,
                  },
                  {
                    path: "vendor-management/work-permit/form/:id",
                    element: <WorkPermitForm />,
                  },
                  {
                    path: "vendor-management/work-permit/form/new",
                    element: <WorkPermitForm />,
                  },
                  {
                    path: "tenant-relation/announcements",
                    element: <Announcements />,
                  },
                  {
                    path: "tenant-relation/Tenant-News",
                    element: <TenantNews />,
                  },
                  {
                    path: "tenant-relation/information",
                    element: <Information />,
                  },
                  {
                    path: "tenant-relation/visitor",
                    element: <MallTraffic />,
                  },
                  {
                    path: "tenant-relation/playup",
                    element: <Playup />,
                  },
                  {
                    path: "tenant-relation/linknet",
                    element: <LinknetPage />,
                  },
                  {
                    path: "workPermit",
                    element: <WorkPermit />,
                  },
                  {
                    path: "workpermit/form/:id",
                    element: <WorkPermitForm />,
                  },
                  {
                    path: "workpermit/form/new",
                    element: <WorkPermitForm />,
                  },
                  {
                    path: "safetyTask",
                    element: <SafetyTask />,
                  },
                  {
                    path: "safetyTask/form/:id",
                    element: <SafetyTaskForm />,
                  },
                  {
                    path: "tenantRequest",
                    element: <TenantRequest />,
                  },
                  {
                    path: "sales/upload",
                    element: <SalesUpload />,
                  },
                  {
                    path: "sales/transaction",
                    element: <Transaction />,
                  },
                  {
                    path: "sales/summary",
                    element: <Summary />,
                  },
                  {
                    path: "sales/revenue-monitor",
                    element: <RevenueMonitor />,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "*",
        element: <Navigate to="/login" replace />,
      },
    ],
  },
], {
  basename: "/"
});

export default function App() {
  return <RouterProvider router={router} />;
}
